import { Locale } from './constants'

export type Translations = Record<string, string>

type TranslationModule = { default: Translations }

/**
 * Pages (extension popup/tab, mobile-web): one webpack chunk per locale, fetched only
 * when that locale is selected. `en` is bundled with the i18n core and never loaded
 * through here. The extension service worker cannot load chunks at runtime and uses
 * `loadTranslationsFromPackage` instead.
 */
const LOADERS: Record<Exclude<Locale, Locale.EN>, () => Promise<TranslationModule>> = {
  [Locale.KO]: () => import(/* webpackChunkName: "i18n-ko" */ './translations/ko.json'),
  [Locale.JA]: () => import(/* webpackChunkName: "i18n-ja" */ './translations/ja.json'),
  [Locale.ZH_CN]: () => import(/* webpackChunkName: "i18n-zh-CN" */ './translations/zh-CN.json'),
  [Locale.ZH_TW]: () => import(/* webpackChunkName: "i18n-zh-TW" */ './translations/zh-TW.json'),
  [Locale.RU]: () => import(/* webpackChunkName: "i18n-ru" */ './translations/ru.json'),
  [Locale.PL]: () => import(/* webpackChunkName: "i18n-pl" */ './translations/pl.json'),
  [Locale.CS]: () => import(/* webpackChunkName: "i18n-cs" */ './translations/cs.json'),
  [Locale.FR]: () => import(/* webpackChunkName: "i18n-fr" */ './translations/fr.json'),
  [Locale.DE]: () => import(/* webpackChunkName: "i18n-de" */ './translations/de.json'),
  [Locale.NL]: () => import(/* webpackChunkName: "i18n-nl" */ './translations/nl.json')
}

export const loadTranslations = async (locale: Exclude<Locale, Locale.EN>) =>
  (await LOADERS[locale]()).default
